import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function FireOutline(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M10.744 2.332A1 1 0 009.02 2.8c-.516 2.526-1.638 4.103-2.735 5.645l-.038.053C5.153 10.034 4 11.655 4 14.077 4 18.817 7.522 22 12 22s8-3.184 8-7.923c0-1.877-.732-4.677-3.099-7.557l-.414-.394a1 1 0 00-1.36.388c-.125.203-.247.407-.37.612-.33.553-.661 1.106-1.025 1.636a10.46 10.46 0 00-.2-1.304c-.345-1.562-1.123-3.274-2.788-5.126zm.835 5.379c-.18-.814-.515-1.717-1.157-2.711-.68 1.86-1.642 3.21-2.474 4.379l-.058.08C6.77 11.034 6 12.179 6 13.9c0 3.569 2.56 5.923 6 5.923s6-2.354 6-5.923c0-1.202-.416-3.138-1.896-5.294-.14.226-.294.467-.456.713a18.277 18.277 0 01-1.119 1.542c-.354.43-.816.925-1.312 1.168a1 1 0 01-1.44-.898c0-.2.003-.397.006-.594.01-.904.022-1.801-.204-2.825z",
    clipRule: "evenodd"
  }));
}

export default FireOutline;